import { render } from "./UpcomingEventsScrollItem.vue?vue&type=template&id=71e8b1fb"
import script from "./UpcomingEventsScrollItem.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsScrollItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__